import { Spinner, Text } from '@wyz/ui';
import { ReactNode } from 'react';

const LegendItem = ({
  label,
  value,
  isLoading,
}: {
  value?: ReactNode;
  label: ReactNode;
  isLoading?: boolean;
}) => (
  <div
    className='d-flex rounded-3 shadow'
    style={{ backgroundColor: '#EBEBEB' }}
  >
    <div className='px-3 py-2 rounded-3 d-flex align-items-center'>
      <Text weight='semi-bold' heading='sm'>
        {label}
      </Text>
    </div>
    <div className='px-3 py-2 rounded-3 bg-white d-flex align-items-center'>
      <Text heading='normal' color='primary' weight='semi-bold'>
        {isLoading ? (
          <Spinner style={{ width: '1rem', height: '1rem' }} />
        ) : (
          value
        )}
      </Text>
    </div>
  </div>
);

export default LegendItem;
